import { Rows } from '../../interfaces';
import { ComparisonByValueWrapper } from './comparison-by-values';
import { formats, getCell, withCellStyles } from '../../utils';
import { boldLightGrayBgLeft, left } from 'src/app/util/excelStyles';
import { intToExcelCol } from 'excel-column-name';
import { MainDataPeriodComparison, PeriodAndFinData } from 'src/app/domain/portfolio-comparison/dto/CompanyFinDataAndCalculations';
export const getPreparedData = (data: ComparisonByValueWrapper) => {
  const newData: Rows = [];
  currentIndex = 1;
  const periodHeaders = ['Company'].concat(data.periods.filteredPeriods.map((el) => el.toString()));
  const onlyDatesHeaders = data.periods.filteredPeriods.map((el) => el.toString());
  newData.push(periodHeaders);
  const selectedTab = data.selectedTab;
  const mappedToHeaders = data.data.map((d) => getNewMapping(d, selectedTab));
  const rows = getRows(mappedToHeaders, periodHeaders);
  newData.push(...rows);
  const totalRow = getTotalRow(onlyDatesHeaders, periodHeaders);
  newData.push(...totalRow);
  return newData;
};

export const getNewMapping = (fin: MainDataPeriodComparison, selectedTab: string) => {
  const body = {
    Company: fin.companyName,
  };
  fin.periodAndFinDatumDto.forEach((finData) => body[finData.period.toString()] = getCell({
    v: getValueByTab(selectedTab, finData),
    z: formats.thousandsSeparator,
    t: 'n',
  }));

  currentIndex++;
  return body;
};

export const getRows = (mappedToHeaders, headers: string[]) => {
  const rows: Rows = [];
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};

export const getTotalMapping = (headers: string[]) => {
  const body = {
    Company: 'Totals',
  };
  const startRow = 2;

  headers.forEach((h,i) => body[h] = getCell({
    f: `SUM(${intToExcelCol(i + 2)}${startRow}:${intToExcelCol(i + 2)}${currentIndex})`,
    z: formats.thousandsSeparator,
    t: 'n',
  }));
  return [body];
};

export const getTotalRow = (headers: string[], allHeaders) => {
  const mappedToHeaders = getTotalMapping(headers);
  const rows: Rows = [];
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of allHeaders) {
      row.push(withCellStyles(mapped[header], boldLightGrayBgLeft));
    }
    rows.push(row);
  }
  return rows;
};

export const getValueByTab = (selectedTab: string, fin: PeriodAndFinData) => {
  switch (selectedTab) {
    case 'Investment':
      return fin.cost;
    case 'Fair value':
      return fin.fairValue;
    case 'Gain/(loss)':
      return fin.gain;
  }
};

export let currentIndex = 1;
